const openPopupIds = new Set();
/**
 * Registers a popup as opened.
 *
 * @param  {string} popupId  The id of the popup.
 */
export function popupOpened(popupId) {
    openPopupIds.add(popupId);
    // console.log(openPopupIds);
}
/**
 * Registers a popup as closed.
 *
 * @param  {string} popupId  The id of the popup.
 */
export function popupClosed(popupId) {
    openPopupIds.delete(popupId);
    // console.log(openPopupIds);
}
/**
 * Returns true if any popup is open.
 *
 * @returns {boolean}  True if any popup is open.
 */
export function isAnyPopupOpen() {
    return openPopupIds.size > 0;
    // console.log(openPopupIds);
}
